import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9fd609a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-date" }
const _hoisted_2 = { class: "section-1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, " 캠페인 일정 ", -1))
const _hoisted_4 = { class: "swiper-wrapper" }
const _hoisted_5 = { class: "box-round" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "round-title" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "container-content" }
const _hoisted_10 = { class: "round-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 모집 기간 ", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "round-row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 참여자 발표 ", -1))
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "round-row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createTextVNode(" 제로 웨이스트 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("박스 발송 ")
], -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "round-row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 수거 신청 기간 ", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))
const _hoisted_23 = { class: "section-2" }
const _hoisted_24 = { class: "desc" }
const _hoisted_25 = { class: "desc" }

import Bg from './bg.vue';
import SwiperComponent from 'swiper';
import { Pagination } from 'swiper/modules';
import { type ComputedRef, type DeepReadonly, type Ref, onMounted, ref, inject, computed } from 'vue';
import SideBottle from './side-bottle.vue';
import { IProgram } from '@/types/program';
import dayjs from 'dayjs';
import Desc from './desc.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const images = inject<ComputedRef<Record<string, string>>>('images')!;

const participate = inject<() => Promise<void>>('participate');
const program = inject<DeepReadonly<Ref<IProgram>>>('program');

const swiperRef = ref<HTMLDivElement>();
onMounted(() => {
  new SwiperComponent(swiperRef.value!, {
    slidesPerView: 1.1,
    spaceBetween: 0,
    modules: [
      Pagination,
    ],
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        pagination: false,
        slidesPerView: 3,
      },
    }
  });
});

const DAY_OF_WEEK_MAP = {
  0: '일',
  1: '월',
  2: '화',
  3: '수',
  4: '목',
  5: '금',
  6: '토'
};
const dateFormat = (time: string, addDay?: number) => {
  let $time = dayjs(time);
  if (addDay) {
    $time = $time.add(addDay, 'day');
  }
  const day = $time.day();
  return `${$time.format('M/D')}(${DAY_OF_WEEK_MAP[day]})`;
};

const bottleImageMap = [
  images.value['bottle-135deg-1-line'],
  images.value['bottle-45deg'],
  images.value['bottle-135deg-1-line'],
];
const rounds = computed(() => {
  return program?.value.program_rounds?.map((item, index) => {
    return {
      participate: [item.participate_started_at, item.participate_ended_at].map(item => dateFormat(item)).join('~'),
      announcement: `${dateFormat(item.participate_ended_at, 2)} 오전 11시`,
      boxDeliver: dateFormat(item.participate_ended_at, 5),
      collect: [item.collection_started_at, item.collection_ended_at].map(item => dateFormat(item)).join('~'),
      bottleImage: bottleImageMap[index % bottleImageMap.length],
      closed: dayjs().isAfter(item.collection_ended_at),
    };
  });
});

const descs1 = [
  '캠페인 참여자로 선정되지 않을까봐 지원을 망설이신다고요?',
  `<div><strong>1,2회차에 참여자로 선정되지 못했다면 3회차 지원 시 <br class="d-block d-md-none">선정 확률 50% UP! </strong><br class="d-none d-md-block">
원더플과 함께 보틀투보틀을 시작하고 <br class="d-block d-md-none">
싶어하는 여러분을 위해 준비했어요.</div>`,
  '원더플 캠페인, 포기하지 말고 계속 함께해 주세요!'
];

const descs2 = [
  '참여자 선정은 100% 추첨으로 진행돼요.',
  `선정 결과는 정해진 일정에 맞춰 카카오 메시지로 <br class="d-block d-md-none">
안내해 드려요.`,
  `제로 웨이스트 박스는 일괄 발송되며, 도착은 지역에<br class="d-block d-md-none">
따라 3~4일 정도 차이 날 수 있어요.`,
  '각 모집 기간은 2주간 진행됩니다.',
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Bg, { class: "bg-section-1" }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", {
            ref_key: "swiperRef",
            ref: swiperRef,
            class: "swiper"
          }, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rounds), (round, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "swiper-slide"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("img", {
                      src: round.bottleImage,
                      class: _normalizeClass(["bottle", [ `bottle-${index}` ]])
                    }, null, 10, _hoisted_6),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(index + 1) + "회차", 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["box-content", { closed: round.closed }])
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createElementVNode("span", _hoisted_12, _toDisplayString(round.participate), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createElementVNode("span", _hoisted_15, _toDisplayString(round.announcement), 1)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _createElementVNode("span", _hoisted_18, _toDisplayString(round.boxDeliver), 1)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _createElementVNode("span", _hoisted_21, _toDisplayString(round.collect), 1)
                        ])
                      ], 2)
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _hoisted_22
          ], 512),
          _createElementVNode("div", {
            class: "btn-submit",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(participate) && _unref(participate)(...args)))
          }, " 참가 지원 ")
        ])
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_23, [
      _createVNode(SideBottle),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(Desc, {
          title: "참여자 선정 확률 UP!",
          value: descs1,
          "start-with-line": false
        })
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(Desc, {
          title: "잠깐!",
          value: descs2
        })
      ])
    ])
  ]))
}
}

})